import React from 'react'
import PropTypes from 'prop-types'

const MenuTrigger = (props) => {
  const { translate } = props
  const handleMenu = () => {
    document.body.classList.add('navigation-visible')
  }

  return (
    <div className='menu-trigger' onClick={handleMenu}>
      <div className='burger-menu'>
        <div className='burger-slice' />
        <div className='burger-slice' />
        <div className='burger-slice' />
      </div>

      <div className='burger-text'>{translate('option.menu')}</div>
    </div>
  )
}

MenuTrigger.propTypes = {
  translate: PropTypes.func.isRequired,
}

export default MenuTrigger
